import axios from 'axios';

const CANCEL_MESSAGE = 'Request canceled'

const cancelRequest = () => {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  
  return {
    token: source.token,
    cancel: source.cancel
  }
}

export {
  CANCEL_MESSAGE,
  cancelRequest
}